import { fetch_asset_bytes } from '../out/client_web';

export function serveSandboxAssets(contentsUrl: string): MessagePort {
    const channel = new MessageChannel();
    const base = new URL('contents/', contentsUrl).href;
    channel.port1.onmessage = async ({ data }) => {
        const { request, url, id } = data;
        try {
            if (typeof id !== 'string' || !/^\d+$/.test(id) || url !== base + id) {
                throw new Error('Invalid sandbox asset request');
            }
            const bytes = await fetch_asset_bytes(url, id);
            channel.port1.postMessage({ request, bytes }, [bytes.buffer]);
        } catch (error) {
            channel.port1.postMessage({ request, error: String(error) });
        }
    };
    return channel.port2;
}

export function useSandboxAssets(port: MessagePort) {
    let nextRequest = 0;
    const pending = new Map<number, { resolve: (bytes: Uint8Array) => void, reject: (error: Error) => void }>();
    port.onmessage = ({ data }) => {
        const request = pending.get(data.request);
        if (!request) return;
        pending.delete(data.request);
        if (data.error) request.reject(new Error(data.error));
        else request.resolve(data.bytes);
    };
    (globalThis as any).fetch_cached_asset = (url: string, id: string) => new Promise<Uint8Array>((resolve, reject) => {
        const request = nextRequest++;
        pending.set(request, { resolve, reject });
        port.postMessage({ request, url, id });
    });
}
